<template>
  <div>
    <div class="footerText">
      <div class="main-container-wrapper">
        <span class="wenzi">{{ text }}</span>
      </div>
    </div>
    <div class="main-container1">
      <div class="main-container-wrapper">
        <div class="main-footer-left">
          <a
            href="//bszs.conac.cn/sitename?method=show&amp;id=0C1EC20C5B04404AE053012819AC0B79"
            target="_blank"
          >
            <img src="../assets/footer_logo.png" alt="党政机关" />
          </a>
          <ul>
            <li>
              <span>主办单位：国家文物局</span>
              <span>版权所有：国家文物局</span>
            </li>
            <li style="width: 800px;">
              <span>运行维护单位: 中国文物信息咨询中心（国家文物局数据中心）</span>
              <span>技术支持电话：010-56792148，010-84849839</span>
            </li>
            <li>
              <span>网站标识码：bm72000002</span>
              <a href="http://beian.miit.gov.cn/" target="_blank"
                >京ICP备13034673号-2</a
              >
              <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102003995" target="_blank">京公安网安备 11010102003995 号</a></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "registerFooter",
  props: [],
  components: {},
  data() {
    return {
      text: "本系统为国家文物局政务服务系统，请自觉遵守国家有关法律、法规和政策，不发布、不传播危害国家安全、危害社会公共利益和社会稳定、违反社会公德的有害信息，抵制一切违法、违规行为。",
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang='less'>
@import "../styles/theme";
.footerText {
  margin-top: 20px;
  height: 30px;
  text-align: center;
  background-color: #b71c1c;
}
.wenzi {
  margin: 0;
  font-size: 12px;
  color: #fff;
  line-height: 30px;
}
.main-container1 {
  height: @height-footer;
  background: #7c2121;
}

.main-footer-left {
  width: 715px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #fff;

  ul {
    margin-left: 1rem;
    list-style: none;
    padding: 0;

    li {
      line-height: 30px;
    }

    span, a {
      margin-right: 24px;
    }
  }
}
</style>
